import * as d3 from 'd3'
export default {
  methods: {

    call_Phase(selection, newArea) {
      selection
      .style('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).attr('opacity', 1)
      })
      .on('click', ()=> {
        d3.select(`#AREA_OUT_${this.current.area.id}`).attr('stroke', '#bcbcbc')
        d3.select(`#AREA_IN_${this.current.area.id}`).attr('fill', '#bcbcbc')

        this.current.area = {name: 'OVERALL', id: 'OV'}
        this.current.disc = {name: 'OVERALL', idx: null}


        // console.log(this.current.area.name, this.current.disc.name)
        this.reflash_Chart()
        // this.set_selectedItems()
      })
    },

    call_Area(selection, newArea) {
      selection
      .style('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).attr('opacity', 1)
      })
      .on('click', ()=> {
        if(this.current.area.id == newArea.id) return

        d3.select(`#AREA_OUT_${this.current.area.id}`).attr('stroke', '#bcbcbc')
        d3.select(`#AREA_IN_${this.current.area.id}`).attr('fill', '#bcbcbc')
        d3.select(`#AREA_OUT_${newArea.id}`).attr('stroke', '#44A9DF')
        d3.select(`#AREA_IN_${newArea.id}`).attr('fill', '#44A9DF')
        this.current.area.id = newArea.id
        this.current.area.name = newArea.name
        this.current.area.title = newArea.title

        d3.select(`#DISC_CHECK_${this.current.disc.idx}`).attr('opacity', 0)
        this.current.disc.idx = null
        this.current.disc.name = 'OVERALL'


        // console.log(this.current.area.name, this.current.disc.name)
        this.reflash_Chart()
        // this.set_selectedItems()
      })
    },


    call_Disc(selection, d, idx) {
      selection
      .style('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).attr('opacity', 1)
      })
      .on('click', ()=> {
        if(this.current.disc.idx == idx) return

        d3.select(`#DISC_CHECK_${this.current.disc.idx}`).attr('opacity', 0)
        d3.select(`#DISC_CHECK_${idx}`).attr('opacity', 1)

        this.current.disc.idx = idx
        this.current.disc.name = d.DISC

        this.reflash_Chart()
        // this.set_selectedItems()

        // console.log(this.current.area.name, this.current.disc.name)
      })
    },


    call_Summary(selection, d, code) {
      let this_ = this
      let cutoff = this_.chartData.find(f=> f.CDATE == this_.timeline.cutoff)

      selection
      .style('cursor', 'pointer')
      .on('mouseover', function() {

        d3.select(this).attr('opacity', .5)
        d3.select(`#SUMMARY`).attr('transform', `translate(${d.mx}, ${this_.chart.height-this_.primary.axis(d[code])})`)
        d3.select(`#SUMMARY`).transition().delay(25).duration(150).attr('opacity', 1)
        d3.select(`#SUMMARY_BOX`).attr('fill', this_.gmx_deltaValue(d.CDATE > this_.timeline.cutoff ? 0 : d[this_.summary.fill.code]))
        this_.reflash_Summary(d)
      })
      .on('mouseout', function() {
        d3.select(this).attr('opacity', 1)
        d3.select(`#SUMMARY`).transition().duration(200).attr('opacity', 0)
      })
    },

    toggle_action() {
      // ON -> OFF (Month -> Week, in this case)
      // Assume that default is always 'ON'
      if (this.toggle == 'off') {
        // Timeline
        if (this.toggleButton.modify.timeline == 'Y') {
          this.timeline.styles.week.tSize
          = this.timeline.styles.week.tSize == 0 ? 10 : 0

          // Back-up current settings
          this.timeline_backup = JSON.parse(JSON.stringify(this.timeline))

          // New setting for week-base
          this.timeline.styles.month.lineY += 3
          this.timeline.styles.month.textY += 7
          this.timeline.styles.year.textY += 7
        }

        // Chart
        if (this.toggleButton.modify.chart == 'Y') {
          this.chart_backup = JSON.parse(JSON.stringify(this.chart))

          this.chart.columns.forEach(d => {
            if (d.type == 'BAR') {
              d.size = this.toggleButton.barWidth
              d.vSize = d.vSize ? d.vSize : 10
            }
          })
        }

        // Legends
        if (this.toggleButton.modify.legends == 'Y') {
          this.legends.apply = this.legends.apply == 'Y' ? 'N' : 'Y'
        }

        // Summary
        if (this.toggleButton.modify.summary == 'Y') {
          this.summary.apply = this.summary.apply == 'Y' ? 'N' : 'Y'
        }

        // Milestone
        if (this.toggleButton.modify.milestone == 'Y') {
          this.milestone.apply = this.milestone.apply == 'Y' ? 'N' : 'Y'
        }

        // Back-up original chartData
        this.chartData_backup = [
          ...this.chartData
        ]

        // // Reset 
        // this.set_chartData()  // ---> set_LocalValues.js

        // Setting alternative chart data
        this.chartData = [
          ...this.chartData_Alt
        ]
      }
      // OFF -> ON (Week -> Month)
      else {
        // Restore back-upped settings
        if (this.toggleButton.modify.timeline == 'Y') {
          this.timeline = JSON.parse(JSON.stringify(this.timeline_backup))

          this.timeline.styles.week.tSize
          = this.timeline.styles.week.tSize == 0 ? 10 : 0
        }
        if (this.toggleButton.modify.chart == 'Y') {
          this.chart = JSON.parse(JSON.stringify(this.chart_backup))
        }
        if (this.toggleButton.modify.legends == 'Y') {
          this.legends.apply = this.legends.apply == 'Y' ? 'N' : 'Y'
        }
        if (this.toggleButton.modify.summary == 'Y') {
          this.summary.apply = this.summary.apply == 'Y' ? 'N' : 'Y'
        }
        if (this.toggleButton.modify.milestone == 'Y') {
          this.milestone.apply = this.milestone.apply == 'Y' ? 'N' : 'Y'
        }

        // Restore back-upped chartData
        this.chartData = [
          ...this.chartData_backup
        ]

        // Restore timeline axis
        this.timeline = {
          ...this.timeline,
          axis: null
        }
        this.timeline.axis = d3.scaleBand()
        .domain(this.chartData.map(d => d.CDATE))
        .range([0, this.chart.width])
      }

      // Remove & Redraw
      // this.canvasChart.remove()
      d3.select(`#CHART_CANVAS`).remove()
      this.canvasBase.remove()
      //this.chart_Router() // Refresh Chart
      

      this.current.toggle = this.toggle
      this.set_selectedItems()

      this.reflash_Toggle()
    },

  }
}